import { Cigar } from '@store/api/cigarApi'
import { CollectionFilters } from '../../features/collection/types/filters'

function compareValues(a: string | number | undefined, b: string | number | undefined, order: 'asc' | 'desc'): number {
  const av = a ?? ''
  const bv = b ?? ''
  if (av < bv) return order === 'asc' ? -1 : 1
  if (av > bv) return order === 'asc' ? 1 : -1
  return 0
}

export function filterOfflineCigars(cigars: Cigar[], filters: CollectionFilters): Cigar[] {
  let result = [...cigars]

  if (filters.search?.trim()) {
    const q = filters.search.trim().toLowerCase()
    result = result.filter(
      (c) =>
        c.brand?.name?.toLowerCase().includes(q) ||
        c.cigarLine?.name?.toLowerCase().includes(q) ||
        c.vitola?.name?.toLowerCase().includes(q) ||
        c.notes?.toLowerCase().includes(q) ||
        c.purchaseLocation?.toLowerCase().includes(q),
    )
  }

  if (filters.brandId) result = result.filter((c) => c.brandId === filters.brandId)
  if (filters.wrapperType) result = result.filter((c) => c.wrapperType === filters.wrapperType)
  if (filters.strengthLevel) result = result.filter((c) => c.strengthLevel === filters.strengthLevel)
  if (filters.vitolaId) result = result.filter((c) => c.vitolaId === filters.vitolaId)
  if (filters.status) result = result.filter((c) => c.status === filters.status)
  if (filters.origin) result = result.filter((c) => c.brand?.country === filters.origin)

  if (filters.purchaseDateStart) {
    const start = new Date(filters.purchaseDateStart).getTime()
    result = result.filter((c) => c.purchaseDate && new Date(c.purchaseDate).getTime() >= start)
  }
  if (filters.purchaseDateEnd) {
    const end = new Date(filters.purchaseDateEnd).getTime()
    result = result.filter((c) => c.purchaseDate && new Date(c.purchaseDate).getTime() <= end)
  }

  const sortBy = filters.sortBy ?? 'brand'
  const sortOrder = filters.sortOrder ?? 'asc'

  result.sort((a, b) => {
    switch (sortBy) {
      case 'purchaseDate':
        return compareValues(a.purchaseDate, b.purchaseDate, sortOrder)
      case 'purchasePrice':
        return compareValues(Number(a.purchasePrice ?? 0), Number(b.purchasePrice ?? 0), sortOrder)
      case 'createdAt':
        return compareValues(a.createdAt, b.createdAt, sortOrder)
      case 'brand':
      default:
        return compareValues(a.brand?.name, b.brand?.name, sortOrder)
    }
  })

  return result
}

export function paginateCigars(cigars: Cigar[], page = 1, limit = 20): { cigars: Cigar[]; total: number; totalPages: number } {
  const total = cigars.length
  const totalPages = Math.max(1, Math.ceil(total / limit))
  const safePage = Math.min(Math.max(1, page), totalPages)
  const start = (safePage - 1) * limit
  return {
    cigars: cigars.slice(start, start + limit),
    total,
    totalPages,
  }
}
